module.exports = __webpack_public_path__ + "static/media/kaidax-profile.70df70c2.webp";